export const handleSubmitBtnState = (button, isSubmitting = true) => {
  if (isSubmitting) {
    // change submit button text
    button.innerText = "Submitting...";
    button.disabled = true;
  } else {
    // change submit button text
    button.innerText = "Submit Form";
    button.disabled = false;
  }
};

/**
 * Show a SweetAlert modal with a custom HTML message.
 * @param {string} htmlMessage - The HTML content of the message to display.
 * @param {function} onOpenCb - Optional callback function to execute when modal opens.
 * @param {function} onCloseCb - Optional callback function to execute after the user interacts with the modal.
 */
export function showSwalMessage(htmlMessage, onOpenCb, onCloseCb) {
  const urlParts = window.location.href.split("#");
  const url = urlParts[0];
  const hash = urlParts[1];
  if (hash === "submitted?action=subscribe") {
    Swal.fire({
      icon: "success",
      html: `<h5 class='text-base mobile:text-sm'>🎉🎉🎉 <br />Thank you for subscribing to our newsletter where we share amazing tips on travelling! Watch out for our amazing contents<br/> <b>Cheers</b></h5>`,

      onClose: () => {
        // change url without reloading the page
        window.history.pushState({}, document.title, url);
      }
    });
  } else if (hash?.includes("submitted")) {
    Swal.fire({
      icon: "success",
      html: htmlMessage,
      onClose: () => {
        // change url without reloading the page
        window.history.pushState({}, document.title, url);
        // INVOKE CALLBACK FN OPTIONALLY
        onCloseCb?.();
      }
    });
    // INVOKE CALLBACK FN OPTIONALLY
    onOpenCb?.();
  } else if (hash?.includes("internal_server_error")) {
    Swal.fire({
      icon: "error",
      html: `<h5 class='text-base mobile:text-sm'> 
       This is a very rare occurence! Please reach out to us via <a href="https://wa.me/2348101257394" class="text-blue-600 underline">Whatsapp</a> if you see this modal. <br/> <strong>Thanks</strong>
      </h5>`,
      onClose: () => {
        // CHANGE URL WITHOUT RELOADING THE PAGE
        window.history.pushState({}, document.title, url);
      }
    });
  }
}

export function getSearchParam(key) {
  // Get the URL fragment
  const fragment = window.location.hash;
  let urlParams = null;
  // Check if fragment exists
  if (fragment) {
    console.log("FOUND FRAGMENT");
    // Remove the leading '#' and split the fragment by '?'
    const fragmentParts = fragment.slice(1).split("?");
    // Get the part after '?' which contains the query parameters
    const queryParams = fragmentParts[1];
    urlParams = new URLSearchParams(queryParams);
  } else {
    console.log("No fragment found in the URL");
    urlParams = new URLSearchParams(window.location.search);
  }

  // console.log(
  //   urlParams,
  //   window.location.search,
  //   window.location.href,
  //   window.location.hash
  // );

  return urlParams.get(key);
}
